import { GET_ASSIGNVEHICLE_FAILED, GET_ASSIGNVEHICLE_REQUESTED, GET_ASSIGNVEHICLE_SUCCESS, GET_LISTASSIGNEDVEHICLE_FAILED, GET_LISTASSIGNEDVEHICLE_REQUESTED, GET_LISTASSIGNEDVEHICLE_SUCCESS, GET_REQUESTVEHICLE_FAILED, GET_REQUESTVEHICLE_REQUESTED, GET_REQUESTVEHICLE_SUCCESS, GET_UPDATEASSIGNDRIVER_FAILED, GET_UPDATEASSIGNDRIVER_REQUESTED, GET_UPDATEASSIGNDRIVER_SUCCESS, GET_UPDATEASSIGNSUBVENDOR_REQUESTED, GET_UPDATEASSIGNSUBVENDOR_SUCCESS, GET_UPDATEASSIGNVEHICLE_FAILED, GET_UPDATEASSIGNVEHICLE_REQUESTED, GET_UPDATEASSIGNVEHICLE_SUCCESS } from "resources/actionTypes";

const initialState = {
  userRequestVehicle: [],
  loading: false,
  error: null,
};
const initialStateListAssignedVehicle = {
  userListAssignedVehicle: [],
  loading: false,
  error: null,
};
const initialStateUpdateAssignVehicle = {
  userUpdateAssignVehicle: [],
  loading: false,
  error: null
}
const initialStateAssignVehicle = {
  userAssignVehicle: [],
  loading: false,
  error: null
}
const initialStateUpdateAssignDriver = {
  userUpdateAssignDriver: [],
  loading: false,
  error: null 
}
const initialStateUpdateAssignSubVendor = {
  userUpdateAssignSubVendor: [],
  loading: false,
  error: null
}

export function userRequestVehicle(state = initialState, action) {
  switch (action.type) {
    case GET_REQUESTVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_REQUESTVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userRequestVehicle: action.userRequestVehicle,
      };
    case GET_REQUESTVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userListAssignedVehicle(state = initialStateListAssignedVehicle, action) {
  switch (action.type) {
    case GET_LISTASSIGNEDVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_LISTASSIGNEDVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userListAssignedVehicle: action.userListAssignedVehicle,
      };
    case GET_LISTASSIGNEDVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAssignVehicle(state = initialStateAssignVehicle, action) {
  switch (action.type) {
    case GET_ASSIGNVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ASSIGNVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userAssignVehicle: action.userAssignVehicle,
      };
    case GET_ASSIGNVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateAssignVehicle(state = initialStateUpdateAssignVehicle, action) {
  switch (action.type) {
    case GET_UPDATEASSIGNVEHICLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEASSIGNVEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateAssignVehicle: action.userUpdateAssignVehicle,
      };
    case GET_UPDATEASSIGNVEHICLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateAssignDriver(state = initialStateUpdateAssignDriver, action) {
  switch (action.type) {
    case GET_UPDATEASSIGNDRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_UPDATEASSIGNDRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateAssignDriver: action.userUpdateAssignDriver,
      };
    case GET_UPDATEASSIGNDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
    return state;
  }
}

export function userUpdateAssignSubVendor(state = initialStateUpdateAssignSubVendor, action) {
  switch (action.type) {
    case GET_UPDATEASSIGNSUBVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case GET_UPDATEASSIGNSUBVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateAssignSubVendor:action.userUpdateAssignSubVendor,
      }
    case GET_UPDATEASSIGNDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
      default:
    return state;
  }
}